<template>
  <BaseDialog
    v-model="showDialog"
    content-width="600px"
    @click:outside="cancelClick"
  >
    <BaseCard class="m_border-none m_bg-white">
      <v-card-title
        v-if="title.length"
        class="text-h5"
      >
        {{ title }}
      </v-card-title>
      <v-card-text v-if="text.length">
        {{ text }}
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="var(--pageErrorFont)"
          text
          @click="cancelClick"
        >
          {{ cancelText }}
        </v-btn>

        <v-btn
          color="var(--pageSuccessFont)"
          text
          @click="confirmClick"
        >
          {{ confirmText }}
        </v-btn>
      </v-card-actions>
    </BaseCard>
  </BaseDialog>
</template>

<script>
import emitter from '@/shared/services/emitter';
import BaseDialog from '@/shared/lib/uikit/components/BaseDialog/BaseDialog.vue';
import BaseCard from '@/shared/lib/uikit/components/BaseCard/BaseCard.vue';

export default {
  name: 'AppConfirmDialog',
  components: { BaseCard, BaseDialog },
  data() {
    return {
      showDialog: false,
      title: '',
      text: '',
      cancelText: '',
      confirmText: '',
    };
  },
  created() {
    emitter.on('openConfirmDialog', data => {
      this.show(data);
    });
  },
  methods: {
    show(data) {
      this.showDialog = true;
      this.title = data.title || '';
      this.text = data.text || '';
      this.cancelText = data.cancelText || 'Отмена';
      this.confirmText = data.confirmText || 'Подтвердить';
    },
    cancelClick() {
      this.returnDefaultData();
      emitter.emit('closeConfirmDialog', { confirmed: false });
    },
    confirmClick() {
      this.returnDefaultData();
      emitter.emit('closeConfirmDialog', { confirmed: true });
    },
    returnDefaultData() {
      this.showDialog = false;
      this.title = '';
      this.text = '';
      this.cancelText = '';
      this.confirmText = '';
    },
  },
};
</script>
